import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _AbLocalToolbar, _class2, _class3;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { observer } from "mobx-react";
import * as React from "react";
/*
 *   Local Toolbars are drawn relative to another component -- either connected at the top (by default),
 *   at the bottom (by setting type="footer") -- or, in fact, as a stand-along toolbar. The goal is for the
 *   styling to work without any extra fidgeting.
 *   @deprecated in favor of AbToolbar
 */
export let AbLocalToolbar = observer(_class = (_AbLocalToolbar = class AbLocalToolbar extends React.Component {
  render() {
    let className = "ab-local-toolbar " + this.props.type;
    if (this.props.className) {
      className += " " + this.props.className;
    }
    return /*#__PURE__*/React.createElement("div", {
      id: this.props.id,
      style: this.props.style,
      "data-test-id": this.props.dataTestId,
      "data-test-component": "ab-local-toolbar",
      className: className
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-toolbar-scrim"
    }), /*#__PURE__*/React.createElement(AbSizeContext.Provider, {
      value: AbSize.SMALL
    }, this.props.children));
  }
}, _defineProperty(_AbLocalToolbar, "defaultProps", {
  type: "header"
}), _AbLocalToolbar)) || _class;

/*
 *   Toolbar Sections distribute toolbar Groups across the toolbar. The first section is rendered on
 *   the left-hand side of the Toolbar.  The last Toolbar Section is rendered on the right-hand side of
 *   the toolbar.  The middle Toolbar Sections are distributed in-between
 */
export let AbLocalToolbarSection = observer(_class2 = class AbLocalToolbarSection extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "ab-local-toolbar-section"
    }, this.props.children);
  }
}) || _class2;
/*
 *   Toolbar Groups are drawn together, with a vertical line separating each element in the group.
 *   By default, the toolbar groups start at the left of the toolbar.  If the Group is within a
 *   Section, it will be placed according to the section
 */
export let AbLocalToolbarGroup = observer(_class3 = class AbLocalToolbarGroup extends React.Component {
  render() {
    const classNames = ["ab-local-toolbar-group", this.props.className ? this.props.className : null, this.props.children && ClassUtils.isInstanceOf(this.props.children, Array) && this.props.children.filter(child => !!child).length === 0 ? "ab-hidden" : null];
    return /*#__PURE__*/React.createElement("div", {
      className: classNames.filter(className => className !== null).join(" "),
      "data-test-id": this.props.dataTestId
    }, this.props.children);
  }
}) || _class3;
//# sourceMappingURL=AbLocalToolbar.js.map
